import { render, staticRenderFns } from "./UnityServiceDashboardForPopup.vue?vue&type=template&id=83cb217e&scoped=true&"
import script from "./UnityServiceDashboardForPopup.vue?vue&type=script&lang=js&"
export * from "./UnityServiceDashboardForPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83cb217e",
  null
  
)

export default component.exports